/* eslint-disable @typescript-eslint/naming-convention, max-len */

import { PatientWorkflowStepMenuResponse } from '@gandalf/model/patient-workflow-step-menu-response';
import { Action } from '@ngrx/store';
import { EncounterScribeSessionResponse } from '@gandalf/model/encounter-scribe-session-response';
import { PatientWorkflowMenuResponse } from '@gandalf/model/patient-workflow-menu-response';

export enum WorkflowActionTypes {
	UPDATE_WORKFLOW_STEP = '[Update Workflow Step] Update Workflow Step.',
	UPDATE_WORKFLOW_SCRIBE_SESSION = '[Update Workflow Scribe Session] Update Workflow Scribe Session.',
	GET_WORKFLOW_MENU_BY_ENCOUNTER_ID = '[Get Workflow Menu By Encounter ID] Gets a Workflow Menu by Encounter ID.',
	GET_WORKFLOW_MENU_BY_ENCOUNTER_ID_SUCCESS = '[Get Workflow Menu By Encounter Id Success] Signals the successful retrieval of a Workflow Menu.',
	GET_WORKFLOW_MENU_BY_ENCOUNTER_ID_FAILURE = '[Get Workflow Menu By Encounter Id Failure] Signals a failed attempt to retrieve a Workflow Menu.',
	REMOVE_WORKFLOW = '[Remove Workflow] Removes the entire workflow from the state.',
}

export class UpdateWorkflowStep implements Action {
	readonly type = WorkflowActionTypes.UPDATE_WORKFLOW_STEP;
	constructor(public payload: { encounterId: number, step: PatientWorkflowStepMenuResponse }) {}
}

export class UpdateWorkflowScribeSession implements Action {
	readonly type = WorkflowActionTypes.UPDATE_WORKFLOW_SCRIBE_SESSION;
	constructor(public payload: { scribeSession: EncounterScribeSessionResponse }) {}
}

export class GetWorkflowMenuByEncounterId implements Action {
	readonly type = WorkflowActionTypes.GET_WORKFLOW_MENU_BY_ENCOUNTER_ID;
	constructor(public payload: { encounterId: number }) {}
}

export class GetWorkflowMenuByEncounterId_Success implements Action {
	readonly type = WorkflowActionTypes.GET_WORKFLOW_MENU_BY_ENCOUNTER_ID_SUCCESS;
	constructor(public payload: { encounterId: number, workflowMenu: PatientWorkflowMenuResponse, scribeSession: EncounterScribeSessionResponse }) {}
}

export class GetWorkflowMenuByEncounterId_Failure implements Action {
	readonly type = WorkflowActionTypes.GET_WORKFLOW_MENU_BY_ENCOUNTER_ID_FAILURE;
	constructor(public payload: { error: any }) {}
}

export class RemoveWorkflow implements Action {
	readonly type = WorkflowActionTypes.REMOVE_WORKFLOW;
	constructor(public payload: { encounterId: number }) {}
}

export type WorkflowActions =
	UpdateWorkflowStep
	| UpdateWorkflowScribeSession
	| GetWorkflowMenuByEncounterId
	| GetWorkflowMenuByEncounterId_Success
	| GetWorkflowMenuByEncounterId_Failure
	| RemoveWorkflow;
